import { useNavigate } from 'react-router-dom';

import enter from './img/enter.png';
import user from './img/user.png';

const LoginBtn = ({signStatus}) => {
    const navigate = useNavigate();
    const handleLogin = () => {
      if(signStatus) {
        navigate('/profile');
      } else {
        navigate('/login');
      }
    };
    return <div>
        <button onClick={handleLogin} className='main-nav-btn showen'>{signStatus ? "Profile" : "Log in"}</button>
        <button onClick={handleLogin} className='main-nav-btn hidden'><img src={signStatus ? user: enter} alt="enter" /></button>
    </div>
}

export default LoginBtn;